const accountInfoResource = (() => {
    const init = (default_config, resource, resource_config) => {
        Object.assign(default_config, resource_config);
        // navigateToLink(resource_config)
        appendHTML(default_config, resource);
    };

    /**
     * appendHTML : appending html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param default_config
     * @param resource
     */

    const appendHTML = (default_config, resource) => {
        default_config.data = getDistinct(default_config)
        for (let i = 0; i < default_config.data.length; ++i) {
            const config_data = default_config.data[i];
            Object.assign(config_data, default_config);
            initScript.getHTMLElementByDelimiter(default_config.html.config[resource].classes.card_item).append(initScript.jsonToHTML(templates[resource].card_item, config_data));
        }
        analyserV2.init_owl_carousel();
        analyserV2.resolvePromise();
        bankAccountSummary(default_config);
        showHighValueTransactions(default_config);
    };

    const bankAccountSummary = (default_config) => {
        if(!default_config.body.config.account_info.moreInfoLink){
            $("#statsLinkButton").hide()
        }
        if(!default_config.body.config.account_info.bank_account_summary){
            return
        }
        var html_skeleton = {
            "table_divs": [
                {
                    "target": {
                        "header": "BASHeader",
                        "row": "BASRow"
                    },
                    "row_parent": {
                        "class": "row data-row"
                    },
                }
            ],
            "headers": Object.keys(default_config.body.config.account_info.bank_account_summary.columns) 
        }
        Object.assign(html_skeleton, default_config.body.config.account_info.bank_account_summary)
        var BAS_config = {};
        BAS_config["table_divs"] = html_skeleton.table_divs;
        BAS_config["data"] = default_config.data; //templateUtil.getColumnWiseData();
        BAS_config["body"] = {"class": default_config.body.class};
        BAS_config["headers"] = html_skeleton.headers;
        BAS_config.table_divs[0].columns = html_skeleton.headers;
        BAS_config["columns"] = html_skeleton.columns;

        templateUtil.appendTabelHeaders(BAS_config);
        templateUtil.appendTabelRows(BAS_config);

        bankAccountStatementSummary(default_config)
    };

    const bankAccountStatementSummary = (default_config) => {
        if(!default_config.body.config.account_info.bank_account_statements){
            return
        }
        var html_skeleton = {
            "table_divs": [
                {
                    "target": {
                        "header": "dataLeft-fixed-acih",
                        "row": "dataLeft-fixed-aci"
                    },
                    "columns": ["bank_name"]
                },
                {
                    "target": {
                        "header": "dataLeft-fixed-acih1",
                        "row": "dataLeft-fixed-aci1"
                    },
                    "columns": ["account_number"]
                },
                {
                    "target": {
                        "header": "dataRight-fixed-acih1",
                        "row": "dataRight-fixed-aci1"
                    },
                    "columns": ["duration_months_actual"]
                },
                {
                    "target": {
                        "header": "dataRight-fixed-acih2",
                        "row": "dataRight-fixed-aci2"
                    },
                    "columns": ["missingMonthsCount"]
                },
                {
                    "target": {
                        "header": "data-head-acih",
                        "row": "mid-panel-aci"
                    },
                    "row_parent": {
                        "class": "data-row  ht30",
                    },
                }
            ],
            "headers": Object.keys(default_config.body.config.account_info.bank_account_statements.columns) 
        }
        Object.assign(html_skeleton, default_config.body.config.account_info.bank_account_statements)
        var durations = default_config.data.map(function(value) {
            return value.duration_months_actual;
        }).join().split(",");

        var presentMonth = new Date();
        var lastNmonths = [] //add present month while init to include current month
        //for all statement uploaded period
        var allMonths = default_config.data.map(function(value) {
            return value.allMonths;
        }).join().split(",");
        for(const [key, value] of Object.entries(allMonths)){
            presentMonth = new Date(value);
            lastNmonths.push(new Date(presentMonth.getFullYear(), presentMonth.getMonth(), "01"))
        }
        // for(var i=0; i<25;i++){ //for last 25 months
            // var mm = presentMonth.getMonth()-1
            // var yy = presentMonth.getFullYear()
            // presentMonth = new Date((mm < 0)?yy-1:yy, (mm < 0)?11:mm, "01")
            // lastNmonths.push(new Date(presentMonth.getFullYear(), presentMonth.getMonth(), "01"))
        // }
        lastNmonths = lastNmonths.join().split(",")
        durations = [...new Set([...durations, ...lastNmonths])].sort(function(a,b){ return new Date(b)-new Date(a); }); //for 25+ months view
        // durations = [...new Set([...durations])].sort(function(a,b){ return new Date(b)-new Date(a); });

        for(var i = 0; i< durations.length; i++){
            var d_o = new Date(durations[i]) 
            var th = (d_o.getMonth()+1)+"-"+d_o.getFullYear()
            html_skeleton.headers.push(th)
            html_skeleton.columns[th] = {
                "value": default_config.months[d_o.getMonth()]+"-"+d_o.getFullYear(),
                "config": {
                    "header": {
                        "class": "label-block p-0 ht30",
                    },
                    "row": {
                        "class": "label-block p-0 ht30"
                    }
                }
            }
        }
        for(var i = 0; i<default_config.data.length; i++){
            var currentValue = default_config.data[i];
            for(var j = 0; j < durations.length; j++){
                var d_o = new Date(durations[j])
                var pivot = (d_o.getMonth()+1)+"-"+d_o.getFullYear();
                var hay = currentValue["duration_months_actual"].map(function(val){
                    val = new Date(val)
                    return (val.getMonth()+1)+"-"+val.getFullYear()
                })
                var hayAllMonths = currentValue["allMonths"].map(function(val){
                    val = new Date(val)
                    return (val.getMonth()+1)+"-"+val.getFullYear()
                })
                if(-1 !== hay.indexOf(pivot)){
                    currentValue[pivot] = [
                        "",
                        "<p class=\"yodlee-stmt legend-stmt\">Yodlee<span class=\"indexTooltip\">"+default_config.months[d_o.getMonth()]+"-"+d_o.getFullYear()+"</span></p>", 
                        "<p class=\"manual-stmt legend-stmt\">Manual<span class=\"indexTooltip\">"+default_config.months[d_o.getMonth()]+"-"+d_o.getFullYear()+"</span></p>"]
                        [currentValue["transaction_source"]]
                }
                else{
                    if(-1 !== hayAllMonths.indexOf(pivot)){
                        currentValue[pivot] = "<p class=\"missing-stmt legend-stmt\">Missing<span class=\"indexTooltip\">"+default_config.months[d_o.getMonth()]+"-"+d_o.getFullYear()+"</span></p>";
                    }
                    else{
                        currentValue[pivot] = "<p class=\"na-stmt legend-stmt\">N/A<span class=\"indexTooltip\">"+default_config.months[d_o.getMonth()]+"-"+d_o.getFullYear()+"</span></p>";
                    }
                }
            }
        }

        var BAS_config = {};
        BAS_config["table_divs"] = html_skeleton.table_divs;
        BAS_config["data"] = default_config.data; //templateUtil.getColumnWiseData();
        BAS_config["body"] = {"class": default_config.body.class};
        BAS_config["headers"] = html_skeleton.headers;
        BAS_config.table_divs[4].columns = initScript.removeUnexpectedElements(html_skeleton.headers, ["bank_name", "account_number", "transaction_source", "duration_months_actual", "missingMonthsCount"]);
        BAS_config["columns"] = html_skeleton.columns;

        templateUtil.appendTabelHeaders(BAS_config);
        templateUtil.appendTabelRows(BAS_config);
        $("#overview-graphs").hide()

        $('#statements_info_header').on('scroll', function () {
            $('#statements_info_rows').scrollLeft($(this).scrollLeft());
        });
        $('#statements_info_rows').on('scroll', function () {
            $('#statements_info_header').scrollLeft($(this).scrollLeft());
        });
        goToGraphsNow(default_config)
    };

    const goToGraphsNow = (default_config) => {
        var color_codes = ["#158cdc", "#fe9006", "#079e89", "#aa55e8", "#cc2481", "#24da0e", "#dccc0e", "#5794e0", "#4d3a67", "#524c5a", "#8a9eab"]
        var graph_data = getTopNAccounts(default_config.data, "average_amountCreditsPerMonth", 5)
        var data1 = graph_data.map(function(value) {
            return initScript.separateNumberByCommaAndRoundOff(value.average_noOfCreditsPerMonth);
        });
        var accounts = graph_data.map(function(value) {
            return value.account_number; //initScript.stringMasking();
        });
        var ll = getLegends(accounts, color_codes)
        $(".distribution-legends").html("<ul>"+ll+"</ul>")
        const chart_config = {
			"id": "#avgNoOfCreditsPieChart",
			"width": 300,
			"height": 180,
			"color": color_codes,
			"is_doller_format": false,
			data: data1
		};
		if (data1.length) charts.pie.init(chart_config);
        else templateUtil.addEmptySection("avgNoOfCreditsPieChart");

        //GRAPH 2
        chart_config.data = graph_data.map(function(value) {
            return initScript.separateNumberByCommaAndRoundOff(value.average_noOfDebitsPerMonth);
        });
        chart_config.id = "#avgNoOfDebitsPieChart";
        if (chart_config.data.length) charts.pie.init(chart_config);
		else templateUtil.addEmptySection("avgNoOfDebitsPieChart");

        //GRAPH 3
        chart_config.data = graph_data.map(function(value) {
            return (value.average_amountCreditsPerMonth);
        });
        chart_config.id = "#avgAmountOfCreditsPieChart";
        chart_config.is_doller_format = true;
        if (chart_config.data.length) charts.pie.init(chart_config);
        else templateUtil.addEmptySection("avgAmountOfCreditsPieChart");
        
        //GRAPH 4
        chart_config.data = graph_data.map(function(value) {
            return (value.average_amountDebitsPerMonth);
        });
        chart_config.id = "#avgAmountOfDebitsPieChart";
        if (chart_config.data.length) charts.pie.init(chart_config);
        else templateUtil.addEmptySection("avgAmountOfDebitsPieChart");
        
        // goToBarGraphs(default_config)
    }

    function getTopNAccounts(arr, key, x){
        let sorted = arr.sort(function(a,b){
            return b[key] - a[key]
        })
        .map(function(value) {
            return {
                "average_amountDebitsPerMonth": value["average_amountDebitsPerMonth"],
                "average_amountCreditsPerMonth": value["average_amountCreditsPerMonth"],
                "average_noOfDebitsPerMonth": value["average_noOfDebitsPerMonth"],
                "average_noOfCreditsPerMonth": value["average_noOfCreditsPerMonth"],
                "average_amountPerCreditTransactions": value["average_amountPerCreditTransactions"],
                "average_amountPerDebitTransactions": value["average_amountPerDebitTransactions"], 
                "account_number": templateEvents.stringMasking(value.account_number)
            }
        })
        let top5other = [];
        if(sorted.length > x){
            top5other = sorted.slice(0,x)
            let remaining = sorted.slice(x).reduce((accumulator, current) => {
                accumulator["average_amountDebitsPerMonth"] += current["average_amountDebitsPerMonth"]
                accumulator["average_amountCreditsPerMonth"] += current["average_amountCreditsPerMonth"]
                accumulator["average_noOfDebitsPerMonth"] += current["average_noOfDebitsPerMonth"]
                accumulator["average_noOfCreditsPerMonth"] += current["average_noOfCreditsPerMonth"]
                accumulator["average_amountPerCreditTransactions"] += current["average_amountPerCreditTransactions"]
                accumulator["average_amountPerDebitTransactions"] += current["average_amountPerDebitTransactions"]
                return accumulator;
            },
            {
                "average_amountDebitsPerMonth": 0,
                "average_amountCreditsPerMonth": 0,
                "average_noOfDebitsPerMonth": 0,
                "average_noOfCreditsPerMonth": 0,
                "average_amountPerCreditTransactions": 0,
                "average_amountPerDebitTransactions": 0, 
                "account_number": "Others"
            })
            top5other.push(remaining);
            return top5other;
        }
        else{
            return sorted;
        }
    }

    function getLegends(localSources,color_codes) {
		let html_legends = "";
		if(!localSources) localSources = [];
        for (let i = 0; i < localSources.length; ++i) {
            let html = initScript.bindAttrsOnHTMLTag("span", "", {
                "style": { "background": color_codes[i] }
            }) + initScript.bindAttrsOnHTMLTag("label", localSources[i]);
            html_legends += initScript.bindAttrsOnHTMLTag("li", html );
		}

        return html_legends;
	}

    const getDistinct = (configData) => {
        let array1 = configData.data;
        const acno = [];
        return array1.reduce((array1, currentValue) => {
            let idx = array1.findIndex(e => e.account_number === currentValue.account_number)
            if (acno.indexOf(currentValue.account_number) === -1) {
                acno.push(currentValue.account_number)
                currentValue["duration_months_actual"] = [];
                currentValue["average_credits"] = (currentValue.no_of_credits < 1) ? 0 : parseFloat((currentValue.credits / currentValue.no_of_credits).toFixed(2))
                currentValue["average_debits"] = (currentValue.no_of_debits < 1) ? 0 : parseFloat((currentValue.debits / currentValue.no_of_debits).toFixed(2))

                currentValue["duration_months_actual"] = getMonthsBetween(stringToDate(currentValue.first_transaction_date), stringToDate(currentValue.last_transaction_date), currentValue["duration_months_actual"])
                currentValue["allMonths"] = getMonthsBetween(stringToDate(currentValue.from_date), stringToDate(currentValue.to_date), [])
                currentValue["missingMonthsCount"] = currentValue["allMonths"].length - currentValue["duration_months_actual"].length;

                currentValue["average_noOfCreditsPerMonth"] = currentValue.no_of_credits / currentValue["duration_months_actual"].length;
                currentValue["average_noOfDebitsPerMonth"] = currentValue.no_of_debits / currentValue["duration_months_actual"].length;
                currentValue["average_amountCreditsPerMonth"] = currentValue.credits / currentValue["duration_months_actual"].length;
                currentValue["average_amountDebitsPerMonth"] = currentValue.debits / currentValue["duration_months_actual"].length;
                currentValue["average_amountPerCreditTransactions"] = (currentValue["average_noOfCreditsPerMonth"] === 0)?0: currentValue["average_amountCreditsPerMonth"] / currentValue["average_noOfCreditsPerMonth"];
                currentValue["average_amountPerDebitTransactions"] = (currentValue["average_noOfDebitsPerMonth"] === 0)?0:currentValue["average_amountDebitsPerMonth"] / currentValue["average_noOfDebitsPerMonth"];

                array1.push(currentValue)
            }
            else {
                array1[idx]["no_of_credits"] += currentValue.no_of_credits
                array1[idx]["no_of_debits"] += currentValue.no_of_debits
                array1[idx]["credits"] += currentValue.credits
                array1[idx]["debits"] += currentValue.debits
                array1[idx]["duration_months"] += currentValue.duration_months

                let fromDate1 = stringToDate(array1[idx]["from_date"])
                let fromDate2 = stringToDate(currentValue.from_date)
                array1[idx]["from_date"] = (fromDate2.getTime() < fromDate1.getTime()) ? currentValue.from_date : array1[idx]["from_date"]

                let toDate1 = stringToDate(array1[idx]["to_date"])
                let toDate2 = stringToDate(currentValue.to_date)
                array1[idx]["to_date"] = (toDate2.getTime() > toDate1.getTime()) ? currentValue.to_date : array1[idx]["to_date"]

                array1[idx]["average_credits"] = (array1[idx].no_of_credits < 1) ? 0 : parseFloat((array1[idx].credits / array1[idx].no_of_credits).toFixed(2))
                array1[idx]["average_debits"] = (array1[idx].no_of_debits < 1) ? 0 : parseFloat((array1[idx].debits / array1[idx].no_of_debits).toFixed(2))

                array1[idx]["duration_months_actual"] = getMonthsBetween(stringToDate(currentValue.first_transaction_date), stringToDate(currentValue.last_transaction_date), array1[idx]["duration_months_actual"])
                array1[idx]["allMonths"] = getMonthsBetween(stringToDate(array1[idx]["from_date"]), stringToDate(array1[idx]["to_date"]), [])
                array1[idx]["missingMonthsCount"] = array1[idx]["allMonths"].length - array1[idx]["duration_months_actual"].length;

                array1[idx]["average_noOfCreditsPerMonth"] = array1[idx].no_of_credits / array1[idx]["duration_months_actual"].length;
                array1[idx]["average_noOfDebitsPerMonth"] = array1[idx].no_of_debits / array1[idx]["duration_months_actual"].length;
                array1[idx]["average_amountCreditsPerMonth"] = array1[idx].credits / array1[idx]["duration_months_actual"].length;
                array1[idx]["average_amountDebitsPerMonth"] = array1[idx].debits / array1[idx]["duration_months_actual"].length;
                array1[idx]["average_amountPerCreditTransactions"] = (array1[idx]["average_noOfCreditsPerMonth"] === 0)?0:array1[idx]["average_amountCreditsPerMonth"] / array1[idx]["average_noOfCreditsPerMonth"];
                array1[idx]["average_amountPerDebitTransactions"] = (array1[idx]["average_noOfDebitsPerMonth"] === 0)?0:array1[idx]["average_amountDebitsPerMonth"] / array1[idx]["average_noOfDebitsPerMonth"];
            }
            return array1
        }, []);
    }


    const getMonthsBetween = (fromDate, toDate, dataArray) => {
        if (undefined === dataArray) dataArray = [];
        var m = fromDate.getMonth() + 1;
        var y = fromDate.getFullYear();
        while (y < toDate.getFullYear() || (y == toDate.getFullYear() && m <= (toDate.getMonth() + 1))) {
            var d_o = new Date(y,m-1,1)
            var pivot = (d_o.getMonth()+1)+"-"+d_o.getFullYear();
            var hay = dataArray.map(function(val){
                val = new Date(val)
                return (val.getMonth()+1)+"-"+val.getFullYear()
            })
            if(-1 === hay.indexOf(pivot)){
                dataArray.push(new Date(y,m-1,1))
            }
            m++;
            if (m > 12) {
                y++;
                m = 1;
            }
        }
        return dataArray;
    }

    const navigateToLink = (conf) => {
        if($("#statsLinkButton").attr("data-visible") && $("#statsLinkButton").attr("data-visible") == "show"){
            $("#bankAccountSummaryInfo").hide();
            $("#statsLinkButton").removeAttr("data-visible");
            $("#statsLinkButton").html("More Information")
        }
        else{
            $("#bankAccountSummaryInfo").show();
            $("#statsLinkButton").attr("data-visible", "show")
            $("#statsLinkButton").html("Hide More Information")
        }
    }

    const stringToDate = (str) => {
        var dateArray = str.split("/")
        return new Date(dateArray[2], dateArray[1] - 1, dateArray[0])
    }

    const showHighValueTransactions = (default_config) => {
        $("." + default_config.body.class).append("<div class='EXTRA'></div>");
        const _resource = "transactions";
        default_config.body.class = "EXTRA";
        default_config.body.resource = [_resource];

        default_config.security_option = initScript.getObjectValue(default_config, "body.security") || {};
        default_config.defaultOptions = initScript.methodWiseOption(null, default_config.apiURL.statements, default_config.security_option);

        const options = default_config.defaultOptions;
        options.data = JSON.parse(options.data);
        options.data.resource = [_resource];
        options.data = JSON.stringify(options.data);
        initScript.toggleLoader(true, true);
        HttpRequest(options, function (res) {
            initScript.toggleLoader(false, true);
            if (!!default_config.slugs) {
                res = responseV2Interceptor(res, default_config.slugs['statements']);
            } else {
                res = responseInterceptor(res);
            }
            res = res && res.data ? res.data.data ? res.data.data : res.data : res;
            res = initScript.getObjectValue(res, "[0].data");
            if (!initScript.isEmpty(res)) {
                default_config.bank_statement_info[_resource] = res;
                initScript.changeHTMLOfAClass(initScript.getHTMLElementByDelimiter(default_config.body.class), initScript.jsonToHTML(templates[_resource].main, Object.assign({}, default_config.api_urls ? default_config.api_urls : {})));
                $(".EXTRA .mainContainer .container .monthly-summery").hide();
                // $(".EXTRA .mainContainer .container .payment-graph").hide();
                // $('.EXTRA .mainContainer .container').children().filter(':not(#tableview)').hide();
                $(".EXTRA .mainContainer .container .payment-graph h4").hide();
                $(".EXTRA .mainContainer .container .payment-graph .sliderbox").hide();
                $(".EXTRA .mainContainer .container .payment-graph .filterbox1").hide();
                $(".EXTRA .mainContainer .container .payment-graph .filterbox3").show();
                // $(".EXTRA .mainContainer .container .payment-graph form fieldset .row .col-8").hide();
                // $(".EXTRA .mainContainer .container .payment-graph form fieldset .row .col-4").addClass("col-12").removeClass("col-4")
                $(".EXTRA .mainContainer .container #graphicalView").hide();
                $("#accountFilterLabel").html("Please select an account")
                resources.init(default_config, _resource);
            } else analyserV2.addAlertBox("Transactions not available for this resource!");
        });
    };

    return {
        init,
        navigateToLink
    };
})();
